"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _userResume = require("@/api/retailer/userResume");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RetailerUserResumeEdit',
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      formdata: [],
      formRule: {
        skuId: [{
          required: true,
          message: '商品规格编码不能为空',
          trigger: 'blur'
        }],
        num: [{
          required: true,
          message: '下单数量不能为空',
          trigger: 'blur'
        }],
        recipientName: [{
          required: true,
          message: '收件人姓名不能为空',
          trigger: 'blur'
        }],
        recipientPhone: [{
          required: true,
          message: '收件人手机号不能为空',
          trigger: 'blur'
        }],
        recipientProvince: [{
          required: true,
          message: '收件人地址-省不能为空',
          trigger: 'blur'
        }],
        recipientCity: [{
          required: true,
          message: '收件人地址-市不能为空',
          trigger: 'blur'
        }],
        recipientArea: [{
          required: true,
          message: '收件人地址-区不能为空',
          trigger: 'blur'
        }],
        recipientStreet: [{
          required: true,
          message: '收件人地址-街道不能为空',
          trigger: 'blur'
        }],
        recipientAddress: [{
          required: true,
          message: '收件人地址-详细地址不能为空',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    open: function open(row) {
      this.dialogVisible = true;
      this.formdata = JSON.parse(JSON.stringify(row));
    },
    handleSubmit: function handleSubmit() {
      var _this = this;
      this.$refs.formRef.validate(function (valid) {
        if (valid) {
          (0, _userResume.userResumeEditApi)(_this.formdata).then(function (res) {
            _this.dialogVisible = false;
            _this.$emit('success');
          });
        }
      });
    }
  }
};